import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { RouterModule } from '@angular/router';
import { LoginFooterComponent } from './login-footer/login-footer.component';
import { LoginLayoutComponent } from './login-layout.component';
import { LoginHeaderComponent } from './login-header/login-header.component';
import { SvgIconComponent } from '../../ui-kit';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    TranslateModule.forChild({}),
    MatToolbarModule,
    IntrackFeatureModule,
    RouterModule,
    SvgIconComponent,
  ],
  exports: [LoginLayoutComponent],
  declarations: [LoginLayoutComponent, LoginHeaderComponent, LoginFooterComponent],
})
export class LoginLayoutModule {}
